import React, { useEffect, useState, useRef, } from 'react'
import { useKhlxrListQuery,} from '../../store/DianShangYeWuApi';
import { Form, Select, Space,} from 'antd';
function ClientContactSelect(props) {
    const {
        defaultId,
        kh_id,
        qy_id,
        placeholder,
        style,
        disabled,
        khlxr_data,
        onChange,
        onClear,
        label,
        wrapperCol,
        required,
        name,
        value: formValue
    } = props;
    const [list,setList] = useState([]);
    // 将空字符串转换为 undefined，以便显示 placeholder
    const normalizedDefaultId = defaultId === '' ? undefined : defaultId;
    const [selectedValue, setSelectedValue] = useState(normalizedDefaultId);
    const [searchValue, setSearchValue] = useState('');
    const [debouncedSearchValue, setDebouncedSearchValue] = useState('');
    const prevDefaultIdRef = useRef(normalizedDefaultId);
    const selectedValueRef = useRef(selectedValue);
    
    // 同步ref中的selectedValue
    useEffect(() => {
        selectedValueRef.current = selectedValue;
    }, [selectedValue]);
    
    // 防抖处理搜索值
    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedSearchValue(searchValue);
        }, 300);
        return () => clearTimeout(timer);
    }, [searchValue]);
    
    const {data,isSuccess,isFetching,refetch} =useKhlxrListQuery({khlxr_qy_id:qy_id,khlxr_name:debouncedSearchValue,khlxr_kh_id:kh_id,},{refetchOnMountOrArgChange:true,skip:!kh_id})
    
    // 使用 ref 存储 onChange，避免在依赖数组中包含它导致无限循环
    const onChangeRef = useRef(onChange);
    useEffect(() => {
        onChangeRef.current = onChange;
    }, [onChange]);
    
    // 使用 ref 存储上一次的 kh_id，只在真正变化时执行
    const prevKhIdRef = useRef(kh_id);
    
    // 监听 props.kh_id 变化，重新加载数据
    useEffect(() => {
        // 只有当 kh_id 真正变化时才执行
        if(kh_id && kh_id !== prevKhIdRef.current) {
            prevKhIdRef.current = kh_id;
            // 当 kh_id 变化时，清空选中值并重新获取数据
            setSelectedValue(undefined);
            if(onChangeRef.current) {
                onChangeRef.current(undefined);
            }
            refetch();
        }
    }, [kh_id, refetch])
    
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){
                const newArr = data.Result.map((item) => {
                    const {khlxr_id,khlxr_name }=item;
                    return {value:khlxr_id,label:khlxr_name,key:khlxr_id }
                })
                setList(newArr);
                // 如果有新数据，检查当前选中值是否在新数据中，如果不在则清空
                const currentValue = selectedValueRef.current;
                if(newArr.length > 0 && currentValue) {
                    const exists = newArr.some(item => item.value === currentValue);
                    if(!exists) {
                        setSelectedValue(undefined);
                        if(onChangeRef.current) {
                            onChangeRef.current(undefined);
                        }
                    }
                }
            } else {
                setList([]);
                // 如果没有数据，清空选中值
                const currentValue = selectedValueRef.current;
                if(currentValue) {
                    setSelectedValue(undefined);
                    if(onChangeRef.current) {
                        onChangeRef.current(undefined);
                    }
                }
            }
        }
    },[data,isSuccess])
    
    // 检查是否有有效数据
    const hasValidData = list.length > 0 && list.some(item => item.value);
    
    // 监听props.defaultId的变化
    useEffect(() => {
        const normalizedId = defaultId === '' ? undefined : defaultId;
        if(normalizedId !== prevDefaultIdRef.current) {
            setSelectedValue(normalizedId);
            prevDefaultIdRef.current = normalizedId;
        }
    }, [defaultId])
    
    // 当Form传递value时，同步更新内部state（用于wrapperCol为null的情况）
    useEffect(() => {
        if(wrapperCol === null && formValue !== undefined) {
            setSelectedValue(formValue);
        }
    }, [formValue, wrapperCol])    
 
    // 如果wrapperCol为null，说明是作为子组件使用，不包装Form.Item
    // 此时如果被Form.Item包裹，需要使用Form传递的value和onChange
    if (wrapperCol === null) {
        // 如果Form传递了value，使用Form的value（受控模式），否则使用内部state
        const valueFromProps = formValue !== undefined ? formValue : selectedValue;
        const handleChange = (value, option) => {
            setSelectedValue(value);
            // 优先使用Form传递的onChange
            if(onChange) {
                onChange(value, option?.label);
            }
        };
        const handleClear = () => {
            setSelectedValue('');
            onChange('', '');
            // 优先使用Form传递的onChange
            if(onChange) {
                onChange('', '');
            }
            if(onClear) {
                onClear();
            }
        };
        const handleQuickSelectWithForm = (khlxr_id, khlxr_name) => {
            setSelectedValue(khlxr_id);
            // 优先使用Form传递的onChange
            if(onChange) {
                onChange(khlxr_id, khlxr_name);
            }
        };
        // 只有在数据加载成功且确实没有数据时才显示提示信息
        // 如果正在加载或没有kh_id，显示Select（即使list为空）
        if (!isFetching && isSuccess && !hasValidData && kh_id) {
            return <span>该客户暂无对接人！</span>;
        }
        
        return (
            <Space>
                <Select
                    key={`select-${kh_id}-${list.length}`}
                    options={list} 
                    value={valueFromProps}
                    onChange={handleChange}
                    placeholder={placeholder || '请选择客户'}
                    style={style}
                    allowClear
                    onClear={handleClear}
                    disabled={disabled}
                    showSearch
                    filterOption={() => true}
                    onSearch={(value) => {
                        setSearchValue(value);
                    }}
                />
                {khlxr_data && khlxr_data.length > 0 && <Space>
                    {khlxr_data.map((item) => {
                        return <a key={item.khlxr_id} onClick={() => handleQuickSelectWithForm(item.khlxr_id, item.khlxr_name)}>{item.khlxr_name}</a>
                    })}
                    </Space>}
            </Space>
        )
    }

    return (
        <Form.Item 
            label={label} 
            required={required}  
            style={{marginBottom: 0,width: '310px'}}
            name={name}
        >
            {!isFetching && isSuccess && !hasValidData && kh_id ? (
                <span style={{width: '230px'}}>该客户暂无部门！</span>
            ) : (
                <Select
                    key={`select-${kh_id}-${list.length}`}
                    options={list} 
                    value={selectedValue}
                    onChange={(value, option) => {
                        setSelectedValue(value);
                        if(onChange) {
                            onChange(value, option?.label);
                        }
                    }}
                    placeholder={placeholder}
                    style={{width: '100%'}}
                    allowClear
                    onClear={() => {
                        setSelectedValue(undefined);
                        if(onClear) {
                            onClear();
                        }
                    }}
                    disabled={disabled}
                    showSearch
                    filterOption={() => true}
                    onSearch={(value) => {
                        setSearchValue(value);
                    }}
                />
            )}
        </Form.Item>
    )
}

export default ClientContactSelect